import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Emits a tick on a fixed interval, driven by a dedicated Web Worker so the cadence is not
 * stalled by background-tab timer throttling (unlike a main-thread RxJS `interval`). The worker
 * is purely a clock; subscribers perform the actual work (e.g. sending a keepalive) on the main
 * thread. The worker is created on subscribe and terminated on teardown.
 */
@Injectable({ providedIn: 'root' })
export class KeepAliveTimerService {

    ticks(intervalMs: number): Observable<void> {
        return new Observable<void>(subscriber => {
            // Fall back to a main-thread interval where Workers are unavailable (e.g. SSR/tests).
            if (typeof Worker === 'undefined') {
                const id = setInterval(() => subscriber.next(), intervalMs);
                return () => clearInterval(id);
            }

            const worker = new Worker(new URL('./keep-alive-timer.worker', import.meta.url));
            worker.onmessage = () => subscriber.next();
            worker.postMessage({ command: 'start', intervalMs });

            return () => {
                worker.postMessage({ command: 'stop' });
                worker.terminate();
            };
        });
    }
}
